// extracted by mini-css-extract-plugin
module.exports = {"container":"_2fIB2x","contentWrapper":"_3H8U5X"};